<template>
  <div>
    <label for="feedbackText">{{ $t('feedback.label') }}</label>
    <v-textarea
      id="feedbackText"
      v-model="text"
      flat
      solo
      auto-grow
      :placeholder="$t('feedback.placeholder')"
      rows="4"
      hide-details
      @focus="sendGtm('feedback free text')"
    />
  </div>
</template>

<script>
export default {
  name: 'FeedbackTextarea',
  computed: {
    text: {
      get() {
        return this.$store.state.profile.feedback.text;
      },
      set(value) {
        this.$store.commit('profile/feedback/setText', value);
      }
    }
  },
  methods: {
    sendGtm(field) {
      this.gtmPush({
        event: 'form_progress',
        'form.field': field,
        'form.name': 'feedback'
      });
    }
  }
};
</script>
